import axios from 'axios';

const clienteAxiosTDA = axios.create({
  baseURL: "https://tda-qa.vwmapps.com.mx/api-qa",
  // baseURL: "https://tda.vwmapps.com.mx/api-prd",
  headers: {
    "Content-Type": "application/json",
    "Authorization": "Bearer " + process.env.REACT_APP_TOMA_DE_AUTO_SERVICIOS_DIGITALES_TOKEN,
  },
});

const clienteAxiosCatalogos = axios.create({
  baseURL: "https://tda-qa.vwmapps.com.mx/api-qa",
  headers: {
    "Content-Type": "application/json",
    "Authorization": "Bearer " + process.env.REACT_APP_TOMA_DE_AUTO_SERVICIOS_DIGITALES_TOKEN_CATALOGOS,
  },
});



export const getMarcas = () => {
  return clienteAxiosCatalogos.get("/marcas");
};

export const getModelos = (idMarca) => {
  return clienteAxiosCatalogos.get("/modelos", { params: { idMarca } });
};

export const getAniosModelo = (idModelo) => {
  return clienteAxiosCatalogos.get("/aniosmodelo", { params: { idModelo } });
};

export const getVersiones = (idAnio) => {
  return clienteAxiosCatalogos.get("/versiones", { params: { idAnio } });
};

export const sendTradeIn = (payload) => {
  return new Promise((resolve, reject) => {
    try {
      const respuesta = clienteAxiosTDA.post("/recibetradein", payload);
      resolve(respuesta);
    } catch (error) {
      console.error("Error en petición de trade-in:", error);
      reject("Error en petición de trade-in");
    }
  });
};
